import { Component, Input, TemplateRef } from '@angular/core';
var NglInternalOutlet = (function () {
    function NglInternalOutlet() {
    }
    NglInternalOutlet.prototype.ngOnChanges = function (changes) {
        _a = this.nglInternalOutlet instanceof TemplateRef
            ? ['', this.nglInternalOutlet]
            : [this.nglInternalOutlet, null], this.content = _a[0], this.contentTemplate = _a[1];
        var _a;
    };
    NglInternalOutlet.decorators = [
        { type: Component, args: [{
                    selector: '[nglInternalOutlet]',
                    template: "{{content}}<ng-template [ngTemplateOutlet]=\"contentTemplate\"></ng-template>",
                },] },
    ];
    /** @nocollapse */
    NglInternalOutlet.ctorParameters = function () { return []; };
    NglInternalOutlet.propDecorators = {
        'nglInternalOutlet': [{ type: Input },],
    };
    return NglInternalOutlet;
}());
export { NglInternalOutlet };
//# sourceMappingURL=outlet.js.map